import { useMemo, useState } from 'react';

type Props = {
  open: boolean;
  title: string;
  description: string;
  entityLabel: string;
  confirmationText: string;
  loading?: boolean;
  error?: string | null;
  requireReason?: boolean;
  onConfirm: (payload: { reason?: string }) => Promise<void> | void;
  onClose: () => void;
  severity?: 'danger' | 'warning' | 'info';
};

export default function DangerActionModal({
  open,
  title,
  description,
  entityLabel,
  confirmationText,
  loading = false,
  error,
  requireReason = false,
  onConfirm,
  onClose,
  severity = 'danger',
}: Props) {
  const [typedValue, setTypedValue] = useState('');
  const [reason, setReason] = useState('');
  const canConfirm = useMemo(() => {
    if (typedValue.trim() !== confirmationText.trim()) return false;
    if (requireReason && !reason.trim()) return false;
    return true;
  }, [typedValue, confirmationText, requireReason, reason]);

  if (!open) return null;

  return (
    <div className="admin-modal-backdrop" role="dialog" aria-modal="true">
      <div className={`admin-modal admin-modal-adaptive admin-modal-${severity}`}>
        <h3 className="admin-card-title">{title}</h3>
        <p>{description}</p>
        <p><strong>Объект:</strong> {entityLabel}</p>
        <label className="admin-field">
          <span className="admin-field-label">Введите `{confirmationText}` для подтверждения</span>
          <input className="admin-input" value={typedValue} onChange={(e) => setTypedValue(e.target.value)} />
        </label>
        {requireReason && (
          <label className="admin-field">
            <span className="admin-field-label">Причина</span>
            <textarea className="admin-input" value={reason} onChange={(e) => setReason(e.target.value)} />
          </label>
        )}
        {error ? <div className="admin-error">{error}</div> : null}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button type="button" className="admin-btn admin-btn-secondary" onClick={onClose} disabled={loading}>Отмена</button>
          <button
            type="button"
            className="admin-btn admin-btn-primary"
            disabled={!canConfirm || loading}
            onClick={() => void onConfirm({ reason: reason.trim() || undefined })}
          >
            {loading ? 'Выполняем...' : 'Подтвердить'}
          </button>
        </div>
      </div>
    </div>
  );
}
